module.exports = __webpack_public_path__ + "img/menunggu_verifikasi.660e539c.svg";